// From http://bjoern.hoehrmann.de/utf-8/decoder/dfa/
// Ref https://stackoverflow.com/questions/1031645/how-to-detect-utf-8-in-plain-c
// TODO: Type as ReadonlyBuffer?
export const utf8d = Buffer.from([
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0, // 00..1f
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0, // 20..3f
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0, // 40..5f
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0, // 60..7f
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	9,
	9,
	9,
	9,
	9,
	9,
	9,
	9,
	9,
	9,
	9,
	9,
	9,
	9,
	9,
	9, // 80..9f
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7,
	7, // a0..bf
	8,
	8,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2,
	2, // c0..df
	0xa,
	0x3,
	0x3,
	0x3,
	0x3,
	0x3,
	0x3,
	0x3,
	0x3,
	0x3,
	0x3,
	0x3,
	0x3,
	0x4,
	0x3,
	0x3, // e0..ef
	0xb,
	0x6,
	0x6,
	0x6,
	0x5,
	0x8,
	0x8,
	0x8,
	0x8,
	0x8,
	0x8,
	0x8,
	0x8,
	0x8,
	0x8,
	0x8, // f0..ff
	0x0,
	0x1,
	0x2,
	0x3,
	0x5,
	0x8,
	0x7,
	0x1,
	0x1,
	0x1,
	0x4,
	0x6,
	0x1,
	0x1,
	0x1,
	0x1, // s0..s0
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	0,
	1,
	1,
	1,
	1,
	1,
	0,
	1,
	0,
	1,
	1,
	1,
	1,
	1,
	1, // s1..s2
	1,
	2,
	1,
	1,
	1,
	1,
	1,
	2,
	1,
	2,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	2,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1, // s3..s4
	1,
	2,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	2,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	3,
	1,
	3,
	1,
	1,
	1,
	1,
	1,
	1, // s5..s6
	1,
	3,
	1,
	1,
	1,
	1,
	1,
	3,
	1,
	3,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	3,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1, // s7..s8
]);
